export default __webpack_public_path__ + "static/media/pinpoinLocationMonitoringSvg.730ae86e.svg";